import { createApi } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../core";
import { toast } from "../../core/toast";


export const subscriptionPaymentApi = createApi({
  reducerPath: "subscriptionPaymentApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["SubscriptionPayment", "SubscriptionPayments"],

  endpoints: (builder) => ({
     }),
});